import Tippy from '@tippyjs/react';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Separator from '~/components/Separator';
import {
  GrupoEmpresa,
  Select,
  StatusPdv,
  tipoMargens,
} from '~/pages/RegraDeEmpresa/protocols';
import { useRegraEmpresa } from '~/pages/RegraDeEmpresa/RegraDeEmpresaContext';
import { LimiteCredito } from './LimiteCredito';

import { FaFlask } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { InputPercent, InputSelect } from '~/components/NovosInputs';
import api from '~/services/api';
import { formatCurrencyBR, transformAsCurrency } from '~/utils/functions';
import { SeparatorNovo } from '~/components/SeparatorNovo';
import ToggleDefault from '~/components/ToggleDefault';

export const AbaGeral: React.FC = () => {
  // States da aba geral
  const [codStatusPdvs, setCodStatusPdvs] = useState<Select[]>([]);
  const {
    formRegraEmpresa,
    handleFormRegraEmpresa,
    isUpdate,
    formTela,
    flgEnviaIbsCbs,
    handleFlgEnviaIbsCbs,
    disabledInputsIbsCbs,
  } = useRegraEmpresa();

  const getGrupos = async () => {
    if (!isUpdate) {
      const res = await api.get('/regraempresa/grupo/0');
      const { data } = res.data;
      data.map((reg: GrupoEmpresa) => {
        return {
          value: reg.cod_grupo_empresa,
          label: reg.des_grupo_empresa,
        };
      });
    } else {
      const res = await api.get('/regraempresa/grupo/1');
      const { data } = res.data;
      data.map((reg: GrupoEmpresa) => {
        return {
          id: reg.cod_grupo_empresa,
          label: `${reg.des_grupo_empresa} (${reg.des_lojas})`,
        };
      });
    }
  };

  async function getStatusPDV() {
    try {
      const res = await api.get(`statuspdv/tipo/0`);
      const { data, success, message } = res.data;

      if (!success) {
        throw new Error(message);
      }

      const regs = data.map((reg: StatusPdv) => {
        return {
          value: reg.cod_status_pdv,
          label: `${reg.cod_status_pdv} - ${reg.des_status_pdv}`,
        };
      });
      setCodStatusPdvs(regs);
    } catch (error: any) {
      toast.error(error.message);
    }
  }

  useEffect(() => {
    getStatusPDV();
    getGrupos();
  }, []);

  function getFormula() {
    const tipo = Number(formRegraEmpresa.tipo_margem.value.value) ?? null;
    switch (tipo) {
      case 0:
        return 'CustoRep*(1+(Margem/100))';
      case 1:
        return `
          CustoSImposto:
          (CustoSICMSE - (CustoRep*((PIS+Cofins)/100.0)))
          ITEM COM PIS/COFINS:
          CustoSImposto/(1-(ICMSS+PIS+Cofins+DespOp/100)-(Margem/100))
          ITEM SEM PIS/COFINS:
          CustoSICMS/(1-(ICMSS+DespOp/100)-(Margem/100))
        `;
      case 2:
        return 'CustoRep/(1-(Margem/100))';
      case 3:
        return `
          CustoSImposto:
          (CustoSICMSE - (CustoRep*((PIS+Cofins)/100.0)))
          ITEM COM PIS/COFINS:
          CustoSImposto/(1-(ICMSS+PIS+Cofins/100)-(Margem/100))
          ITEM SEM PIS/COFINS:
          CustoSICMS/(1-(ICMSS/100)-(Margem/100))
        `;
      default:
        return 'Selecione um tipo de margem';
    }
  }

  const formula = getFormula();

  return (
    <>
      <Row>
        <Col sm={12} md={12}>
          <Separator labelText="Custos" />
        </Col>
        <Col sm={12} md={5}>
          <InputSelect
            label="Margem p/ Cálculo de Preço de Venda"
            changeSelected={(value: Select) => {
              formTela.setValue('tipo_margem', value);
              handleFormRegraEmpresa({
                ...formRegraEmpresa,
                tipo_margem: {
                  ...formRegraEmpresa.tipo_margem,
                  value,
                  isInvalid: value.value === undefined,
                },
              });
            }}
            options={tipoMargens as any[]}
            name="tipo_margem"
            isError={!!formTela.formState.errors.tipo_margem}
            register={formTela.register}
            control={formTela.control}
            placeholder="Selecione a Margem"
          />
        </Col>
        <Col sm={12} md={1}>
          <div style={{ marginTop: '32px' }}>
            <Tippy
              placement="top"
              content={formula}
              arrow
              animation="scale"
              appendTo={() => document.body}
              trigger="mouseenter focus"
              zIndex={9999}
            >
              <span
                style={{ display: 'inline-flex', alignItems: 'stretch' }}
                onClick={(e) => e.stopPropagation()}
              >
                <FaFlask size={30} color="#8850BF" className="formula-icon" />
              </span>
            </Tippy>
          </div>
        </Col>
        {/*
        ----- campo ocultado task: 2838 -----
         <Col sm={12} md={6}>
          <InputSelect
            label="Custo Médio Baseado no Custo"
            onChange={(value: Select) => {
              formTela.setValue('tipo_custo', value);
              handleFormRegraEmpresa({
                ...formRegraEmpresa,
                tipo_custo: {
                  ...formRegraEmpresa.tipo_custo,
                  value,
                  isInvalid: value.value === undefined,
                },
              });
            }}
            options={tipoCustos}
            isRequired={formRegraEmpresa.tipo_custo.isRequired}
            setInvalid={formRegraEmpresa.tipo_custo.isInvalid}
            iniInicializado={inicializado}
            value={
              tipoCustos.find((item: Select) => {
                return item.value === formRegraEmpresa.tipo_custo.value.value;
              }) ?? {
                value: undefined,
                label: '- Selecione o Custo -',
              }
            }
          />
        </Col> */}
      </Row>
      <Row>
        <Col sm={12} md={6}>
          <Separator labelText="Atualização de Custos" />
          <Row>
            <Col sm={12} md={6}>
              <InputPercent
                label="% Tolerância Até Emitir Aviso"
                name="per_tol_custo"
                max={9999999}
                control={formTela.control}
                register={formTela.register}
                isError={!!formTela.formState.errors.per_tol_custo}
                min={0}
                placeholder="0,00"
                onInput={(ev: any) => {
                  const { value } = ev.target;

                  formTela.setValue('per_tol_custo', formatCurrencyBR(value));
                  handleFormRegraEmpresa({
                    ...formRegraEmpresa,
                    per_tol_custo: {
                      ...formRegraEmpresa.per_tol_custo,
                      value: formatCurrencyBR(value),
                      isInvalid:
                        transformAsCurrency(formatCurrencyBR(value)) === 0,
                    },
                  });
                }}
              />
            </Col>
            <Col sm={12} md={6}>
              <InputPercent
                label="% Tolerância Até Emitir Bloqueio"
                name="per_bloq_custo"
                max={9999999}
                control={formTela.control}
                register={formTela.register}
                isError={!!formTela.formState.errors.per_bloq_custo}
                min={0}
                placeholder="0,00"
                onInput={(ev: any) => {
                  const { value } = ev.target;

                  formTela.setValue('per_bloq_custo', formatCurrencyBR(value));
                  handleFormRegraEmpresa({
                    ...formRegraEmpresa,
                    per_bloq_custo: {
                      ...formRegraEmpresa.per_bloq_custo,
                      value: formatCurrencyBR(value),
                      isInvalid:
                        transformAsCurrency(formatCurrencyBR(value)) === 0,
                    },
                  });
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col sm={12} md={6}>
          <Separator labelText="Atualização Preço de Venda" />
          <Row>
            <Col sm={12} md={6}>
              <InputPercent
                label="% Tolerância Até Emitir Aviso"
                name="per_tol_venda"
                max={9999999}
                control={formTela.control}
                register={formTela.register}
                isError={!!formTela.formState.errors.per_tol_venda}
                min={0}
                placeholder="0,00"
                onInput={(ev: any) => {
                  const { value } = ev.target;

                  formTela.setValue('per_tol_venda', formatCurrencyBR(value));
                  handleFormRegraEmpresa({
                    ...formRegraEmpresa,
                    per_tol_venda: {
                      ...formRegraEmpresa.per_tol_venda,
                      value: formatCurrencyBR(value),
                      isInvalid:
                        transformAsCurrency(formatCurrencyBR(value)) === 0,
                    },
                  });
                }}
              />
            </Col>
            <Col sm={12} md={6}>
              <InputPercent
                label="% Tolerância Até Emitir Bloqueio"
                name="per_bloq_venda"
                max={9999999}
                control={formTela.control}
                register={formTela.register}
                isError={!!formTela.formState.errors.per_bloq_venda}
                min={0}
                placeholder="0,00"
                onInput={(ev: any) => {
                  const { value } = ev.target;

                  formTela.setValue('per_bloq_venda', formatCurrencyBR(value));
                  handleFormRegraEmpresa({
                    ...formRegraEmpresa,
                    per_bloq_venda: {
                      ...formRegraEmpresa.per_bloq_venda,
                      value: formatCurrencyBR(value),
                      isInvalid:
                        transformAsCurrency(formatCurrencyBR(value)) === 0,
                    },
                  });
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12} className="mt-4 mb-2">
          <SeparatorNovo
            lineWidth="99%"
            align="left"
            leftLabel
            childrenPosition="left"
            childrenPadding="0 20px 0 0"
            childrenBorder={false}
            containerBackground="#ffffff"
          >
            <ToggleDefault
              labelText="Enviar/Considerar Alíquotas teste de IBS/CBS nos documentos
              Fiscais?"
              name="flg_envia_ibs_cbs"
              inLine
              labelOnRight
              setChecked={flgEnviaIbsCbs}
              onSwitch={() => handleFlgEnviaIbsCbs(!flgEnviaIbsCbs)}
            />
          </SeparatorNovo>
        </Col>
        <Col sm={12} md={3}>
          <InputPercent
            label="CBS"
            placeholder="0,00"
            name="per_cbs_teste"
            register={formTela.register}
            control={formTela.control}
            isError={!!formTela.formState.errors.per_cbs_teste}
            max={100}
            min={0}
            disabled={disabledInputsIbsCbs.cbs}
          />
        </Col>
        <Col sm={12} md={3}>
          <InputPercent
            label="IBS Est"
            placeholder="0,00"
            name="per_ibs_uf_teste"
            register={formTela.register}
            control={formTela.control}
            isError={!!formTela.formState.errors.per_ibs_uf_teste}
            max={100}
            min={0}
            disabled={disabledInputsIbsCbs.ibs_uf}
          />
        </Col>
        <Col sm={12} md={3}>
          <InputPercent
            label="IBS Mun"
            placeholder="0,00"
            name="per_ibs_mun_teste"
            register={formTela.register}
            control={formTela.control}
            isError={!!formTela.formState.errors.per_ibs_mun_teste}
            max={100}
            min={0}
            disabled={disabledInputsIbsCbs.ibs_mun}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12}>
          <Separator labelText="Vincular Status PDV ao Inativar Cliente:" />
          <Col sm={12}>
            <InputSelect
              label="Status PDV"
              changeSelected={(value: Select) => {
                formTela.setValue('cod_status_pdv', value);
                handleFormRegraEmpresa({
                  ...formRegraEmpresa,
                  cod_status_pdv: {
                    ...formRegraEmpresa.cod_status_pdv,
                    value,
                    isInvalid: value.value === undefined,
                  },
                });
              }}
              options={codStatusPdvs as any[]}
              name="cod_status_pdv"
              isError={!!formTela.formState.errors.cod_status_pdv}
              register={formTela.register}
              control={formTela.control}
              placeholder="Selecione o Status"
            />
          </Col>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <LimiteCredito />
        </Col>
      </Row>
    </>
  );
};
